// base
import { chartDashboardBoxStyle } from 'styles';

// libraries
import styled from 'styled-components';

export const StyledTimeCard = styled.div`
  ${chartDashboardBoxStyle}

  position: relative !important;
  width: 457px;
  min-width: 457px;
  height: 290px;

  .time-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 22px;

    p {
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 20px;

      &:last-of-type {
        color: var(--color-update-gray);
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
    }
  }

  .time-wrapper {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .time {
      font-size: 36px;
      font-weight: 500;
      margin-right: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .gst {
      font-size: 12px;
      font-weight: 600;
    }

    p {
      font-size: 12px;
      font-weight: 400;
      color: #8b8b8b;
      margin-top: 8px;
    }
  }

  .clock-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 24px;

    .clock {
      width: 128px;
      height: 128px;
    }
  }

  .day-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;

    h2 {
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 20px;
    }
  }
`;
